module.exports = __webpack_public_path__ + "img/Dash_mini_phone.3397b59e.svg";